<template>
  <div class="v-d-good-take-care">
    <img class="deco-img blue-deco" src="@/assets/img/index/bg_kv_2_blue.svg" />
    <img class="deco-img pink-deco" src="@/assets/img/index/bg_kv_2_pink.svg" />

    <div class="g-content v-d-good-take-care__content">
      <div class="text">
        <p class="title">
          <span class="title__text">讓每個早產兒接受適當的醫療</span>
          <span class="title__text">並提昇早產兒醫療照顧品質</span>
        </p>
        <div class="deco-line"></div>

        <div class="desc">
          <p class="desc__text">
            早產兒基金會透過各界的協助，為早產兒及其家庭點燃信心與希望；同時也藉由各種活動，推廣正確的觀念與知識，以
            防早產的發生。這是一份生命事業，願凝聚你我的關懷，幫助早產兒，準備他還來不及準備的那一部份。
          </p>
        </div>

        <div class="btn-wrap">
          <pr-button arrow @click="toMedicalAllowance">瞭解更多</pr-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import PrButton from '@/components/Global/PrButton.vue';

export default defineComponent({
  name: 'FirstView',
  components: {
    PrButton,
  },
  setup() {
    const router = useRouter();

    const toMedicalAllowance = () => {
      router.push({
        name: 'medical-allowance',
      });
    };

    return {
      toMedicalAllowance,

    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';
.v-d-good-take-care {
  background-image: url('~@/assets/img/index/bg_kv_2.png');

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  &__content {
    height: 100%;
    position: relative;
    @include flex();
  }

  &__content.g-content {
    padding-top: 50px;
    padding-bottom: 50px;

  }
}

.blue-deco {
  width: 100%;

  @include position(tl, -1px, 0);
  z-index: 10;
}

.pink-deco {
  width: 100%;
  @include position(bl, -1px, 0);
}

.title {
  &__text {
    display: block;
    @include font-style($c-white, 20, 500, 1px, 28px);
    text-shadow: 0px 3px 6px #00000029;
  }
}

.desc {
  margin-top: 32px;

  &__text {
    @include font-style($c-white, 14, normal, 1.2px, 28px);
    text-align: justify;
  }
}

.main-services {
  width: 100%;
  @include flex(space-between);
  @include position(tl, calc(100% - 45px), 50%);
  transform: translateX(-50%);
}

.deco-line {
  background-color: $c-main-yellow;
  margin-top: 32px;
  display: inline-block;
  width: 100px;
  height: 5px;
}

.btn-wrap {
  margin-top: 28px;
}

@media screen and (min-width: $mobile) {
  .v-d-good-take-care {
    &__content.g-content {
      @include padding(50px 0px);
    }
  }
}

@media screen and (min-width: $portrait) {
}

@media screen and (min-width: $tablet) {
  .v-d-good-take-care {
    &__content.g-content {
      @include padding(45px 0px);
    }
  }

  .title {
    &__text {
      display: block;
      @include font-style($c-white, 25, 500, 1.4px);
    }
  }

  .desc {
    margin-top: 32px;

    &__text {
      @include font-style($c-white, 16, normal, 1.6px, 28px);
    }
  }
}

@media screen and (min-width: $pc) {
  .v-d-good-take-care {
    &__content.g-content {
      @include padding(300px 0px);
    }
  }

  .title {
    &__text {
      display: block;
      @include font-style($c-white, 35, 500, 1.4px);
    }
  }

  .desc {
    margin-top: 32px;

    &__text {
      @include font-style($c-white, 20, normal, 1.4px);
    }
  }
}
</style>
